module.exports = __webpack_public_path__ + "img/xmasParty4.481ce65c.jpg";